import * as React from 'react';
import * as styles from '../styles/notificationStyles';
import { UserProfilePicture } from '../../app/content/UserProfilePicture';
import { UserNotificationType } from '../contentProviders/UserNotificationType';
import { NotificationIcons } from '../contentProviders/NotificationIcons';

export interface NotificationIconProps {
  notificationType: UserNotificationType;
  displayName: string;
  imageUrl: string;
}

export class NotificationIcon extends React.PureComponent<NotificationIconProps> {

  public render(): JSX.Element {

    const secondImageUrl = this.getSecondImageUrl();

    return (
      <div style={styles.profileImageContainer}>
        <UserProfilePicture
          profileDisplayName={this.props.displayName}
          imageUrl={this.getMainImageUrl()}
          imageSize={styles.userProfileSize}
          fontSize={styles.userProfileTextSize} />
        {secondImageUrl && <div className='profile-second-image' style={styles.userProfileSecondImage(secondImageUrl)} />}
      </div>
    );
  }

  private getMainImageUrl(): string {
    if (NotificationIcons[this.props.notificationType]) {
      return NotificationIcons[this.props.notificationType].isProfile ? this.props.imageUrl : NotificationIcons[this.props.notificationType].systemImageUrl;
    }
    return this.props.imageUrl;
  }

  private getSecondImageUrl(): string {
    return NotificationIcons[this.props.notificationType]?.secondImageUrl;
  }
}